import { useMutation } from "@apollo/client";

import { SettingsSpeciesEditRoute_DeleteDocument } from "../mutations.generated";

export default function useSettingsSpeciesEditRoute_Delete() {
    const [mutate, { loading, error }] = useMutation(SettingsSpeciesEditRoute_DeleteDocument);

    const deleteSpecies = async (speciesId: string) => {
        mutate({ variables: { input: { speciesId } } });
    };

    return {
        deleteSpecies,
        loading,
        error,
    };
}
